<template>
  <div>

    <basic-table
      :items="accountingPeriod"
      :fields="accountingPeriodFields"
      @RowSelected="accountingPeriodSelected"
      @ClickOnEditButton="onRowDoubleClick"/>

      <modal-ok-cancel @save="selectAccoutingPeriod" @cancel="hideAccoutingPeriod" saveButtonLabel="Ok" size="lg"/>
  </div>
</template>

<script>
export default {
  data () {
    return {
      selectedAccountingPeriod: null,
      accountingPeriodFields: [
        {key: 'static_id', label: 'ID', sortable: true},
        {key: 'id', label: this.$i18n.t('Serial ID'), sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'begin', label: this.$i18n.t('Start date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'end', label: this.$i18n.t('End date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'namePeriodicType', label: this.$i18n.t('Period type'), sortable: true}
      ]
    }
  },
  methods: {
    onRowDoubleClick (item) {
      this.selectedAccountingPeriod = item
      this.selectAccoutingPeriod()
    },
    accountingPeriodSelected (row) {
      this.selectedAccountingPeriod = row
    },
    selectAccoutingPeriod () {
      if (!this.selectedAccountingPeriod) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select accounting period'), 'Error')
        return
      }
      this.$emit('input', this.selectedAccountingPeriod.id)
      this.$emit('hideAccoutingPeriod')
    },
    hideAccoutingPeriod () {
      this.$emit('hideAccoutingPeriod')
    }
  },
  computed: {
    accountingPeriod () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/ACCOUNTING_PERIODS']))
      copy = copy.filter(function (value) {
        return value.static_id !== 0
      })
      for (let el of copy) {
        el.namePeriodicType = ''
        switch (el.periodic_type) {
          case 1:
            el.namePeriodicType = this.$i18n.t('Daily')
            break
          case 2:
            el.namePeriodicType = this.$i18n.t('Weekly')
            break
          case 3:
            el.namePeriodicType = this.$i18n.t('Monthly')
            break
          case 4:
            el.namePeriodicType = this.$i18n.t('Quarterly')
            break
          case 5:
            el.namePeriodicType = this.$i18n.t('Annual')
            break
          case 1048576:
            el.namePeriodicType = this.$i18n.t('Custom duration')
            break
        }
      }
      return copy
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formAccountingPeriod.vue